<template>
<div class="view-pages">
    
    <v-navigation-drawer
      stateless
      clipped
      right
      absolute
      v-model="contextDrawer"
    >
      <v-list dense>
        <v-list-tile @click.native="contextDrawer = !contextDrawer">
          <v-list-tile-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Pages View Drawer</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>


    <div v-for="(page, i) in pages" v-bind:key="i">
        <h2 class="py-3">{{ page.title }}</h2>
    </div>


  

</div>
</template>



<script>
import { db } from '@/main'

export default {
    data () {
        return {
            contextDrawer: true,
            pages: []
        }
    },
    firestore () {
      return {
        pages: db.collection('pages').orderBy('createdAt')
      }
    }
}
</script>

<style>

</style>
